import { render, staticRenderFns } from "./RecentSalesLeadsChart.vue?vue&type=template&id=a6d15698&scoped=true&"
import script from "./RecentSalesLeadsChart.vue?vue&type=script&lang=js&"
export * from "./RecentSalesLeadsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d15698",
  null
  
)

export default component.exports